import { ClassroomType, ElementaryUnit } from '../../peekapak-types/DataProtocolTypes';
import { elementaryUnits } from '../components/LibraryCard/cardData';
import { getUnit } from '../core/context/contextHelpers';
import { getLetterGradeFromNumberGrade, getUsersEnableContentTags } from '../GlobalFunctions';
import { getLessonStepUrl } from '../LessonPlan/UtilityFunctions';

export function getCurriculumNames() {
  console.log('FUWDYFUJWEYEWJYDJDJHWEA');
  console.log([
    'Self-RegulationMena',
    'RespectMena',
    'GratitudeMena',
    'KindnessMena',
    'PerseveranceMena',
    'TeamworkMena',
    'EmpathyMena',
    'HonestyMena',
    'OptimismMena',
    'CourageMena',
    'Arabic-Calligraphy',
    'Gratitude-Ramadan',
    'Kindness-Dates',
    'Empathy-Poetry',
    'Teamwork-Tolerance',
  ]);
  const enabledContentTags = getUsersEnableContentTags();
  if (enabledContentTags && enabledContentTags.includes('mena')) {
    return [
      'Self-RegulationMena',
      'RespectMena',
      'GratitudeMena',
      'KindnessMena',
      'PerseveranceMena',
      'TeamworkMena',
      'EmpathyMena',
      'HonestyMena',
      'OptimismMena',
      'CourageMena',
      'Arabic-Calligraphy',
      'Gratitude-Ramadan',
      'Kindness-Dates',
      'Empathy-Poetry',
      'Teamwork-Tolerance',
    ];
  }
  return [
    'Self-Regulation',
    'Respect',
    'Gratitude',
    'Kindness',
    'Perseverance',
    'Teamwork',
    'Empathy',
    'Honesty',
    'Optimism',
    'Courage',
    'Arabic-Calligraphy',
    'Gratitude-Ramadan',
    'Kindness-Dates',
    'Empathy-Poetry',
    'Teamwork-Tolerance',
  ];
}

// Elementary Unit IDs are formulated as follows: [language code]-[curriculumName]-[grade]
// This function returns the root unit name from the unit ID
function getRootUnitName(unitId: string) {
  return unitId.split('-').slice(0, -1).join('-');
}

const supplementaryUnits = elementaryUnits.filter((item) => item.filterTags.includes('supplementary'));

export const getElementaryCompletion = (completionStatus: ClassroomType['completionStatus']) => {
  return Object.keys(completionStatus)
    .filter((key) => getCurriculumNames().includes(getRootUnitName(key)))
    .reduce<ClassroomType['completionStatus']>((obj, key) => {
      (obj[key as keyof ClassroomType['completionStatus']] as unknown) = completionStatus[key];
      return obj;
    }, {});
};

export const getSupplementaryCompletion = (completionStatus: ClassroomType['completionStatus'], grade: number) => {
  const supplementaryUnitsFilteredByGrade = supplementaryUnits.filter((unit) => unit.gradeSpan.includes(grade));
  return Object.keys(completionStatus)
    .filter((key) => supplementaryUnitsFilteredByGrade.map((unit) => unit.unit).includes(getRootUnitName(key)))
    .reduce<ClassroomType['completionStatus']>((obj, key) => {
      (obj[key as keyof ClassroomType['completionStatus']] as unknown) = completionStatus[key];
      return obj;
    }, {});
};

export const getNumModules = (elementaryCompletion: ClassroomType['completionStatus']) =>
  Object.values(elementaryCompletion).flat(Infinity).length;

export const getNumCompleteModules = (elementaryCompletion: ClassroomType['completionStatus']) => {
  return Object.values(elementaryCompletion)
    .flat(Infinity)
    .reduce((acc, curr) => {
      if (curr === 'Completed') acc += 1;
      return acc;
    }, 0);
};

export const getUnitCompletion = (elementaryCompletion: ClassroomType['completionStatus'], grade: number) => {
  const letterGrade = getLetterGradeFromNumberGrade(grade);
  const completionUnits = elementaryUnits.filter((unit) =>
    Object.keys(elementaryCompletion).includes(`${unit.unit}-${letterGrade}`),
  );
  return completionUnits.map((unit) => {
    return {
      id: unit.unit,
      displayName: unit.displayName,
      totalModules: elementaryCompletion[`${unit.unit}-${letterGrade}`]
        ? elementaryCompletion[`${unit.unit}-${letterGrade}`].flat(Infinity).length
        : 1,
      completeModules: elementaryCompletion[`${unit.unit}-${letterGrade}`]
        ? elementaryCompletion[`${unit.unit}-${letterGrade}`].flat(Infinity).reduce((acc: number, curr: string) => {
            if (curr === 'Completed') acc += 1;
            return acc;
          }, 0)
        : 0,
    };
  });
};

export const getUnits = async (language: string, grade: number) => {
  const lessonData: ElementaryUnit[] = [];
  const letterGrade = getLetterGradeFromNumberGrade(grade);
  await getCurriculumNames().reduce(async (promise, unit) => {
    const name = `${language}-${unit}-${letterGrade}`;
    const version = 'published';
    const unitInfo = {
      keys: { name, version },
      lessonMeta: {}, //placeholder
      lastVersion: 0, //placeholder
    };
    await promise;

    const lesson: ElementaryUnit = await getUnit(unitInfo);
    lessonData.push(lesson);
  }, Promise.resolve());
  console.log(lessonData);
  return lessonData;
};

const filterNestedByKey = (object: ElementaryUnit[], key: string, returnKey?: string) => {
  let ret: string[] = [];
  if (Object.prototype.hasOwnProperty.call(object, key)) {
    ret = [...ret, object[returnKey ? returnKey : key]];
  }
  if (Object.keys(object).length) {
    for (let i = 0; i < Object.keys(object).length; i++) {
      const value = object[Object.keys(object)[i]];
      if (typeof value === 'object' && value != null) {
        const o = filterNestedByKey(object[Object.keys(object)[i]], key);
        if (o != null && o instanceof Array) {
          ret = [...ret, ...o];
        }
      }
    }
  }
  return ret;
};

export const getAllApplicableStandards = (units: ElementaryUnit[]) => {
  const standards = filterNestedByKey(units, 'coreStandards').flat();
  return standards;
};

export interface ElementaryLessonWithStandards {
  unitId: string;
  unitNum: number;
  displayName: string;
  standards: string[];
  title: string;
  label: string;
  url: string;
}
export type ElementaryLessonsWithStandards = ElementaryLessonWithStandards[];

export const getCompletedLessonsWithStandards = (
  elementaryCompletion: ClassroomType['completionStatus'],
  units: ElementaryUnit[],
  classroomName: string,
) => {
  return Object.entries(elementaryCompletion).reduce(
    (acc, curr) => {
      curr[1].forEach((subUnitCompletion: string[][], subUnitIndex: number) => {
        subUnitCompletion.forEach((lessonCompletion: string[], lessonIndex: number) => {
          lessonCompletion.forEach((activityCompletion: string, activityIndex: number) => {
            const unitObject = units.find((unit) => unit.value.lessonPlan.title === getRootUnitName(curr[0]))?.value;
            const subUnitObject = unitObject?.lessonPlan.subUnits[subUnitIndex];
            const lessonObject = subUnitObject?.lessons[lessonIndex];
            acc[activityCompletion === 'Completed' ? 0 : 1].push({
              unitId: getRootUnitName(curr[0]),
              unitNum: elementaryUnits.map((unit) => unit.unit).indexOf(getRootUnitName(curr[0])) + 1,
              displayName:
                elementaryUnits.find((unit) => unit.unit === getRootUnitName(curr[0]))?.unit ||
                getRootUnitName(curr[0]),
              standards: lessonObject?.activities[activityIndex]?.coreStandards || [],
              title: lessonObject?.activities[activityIndex]?.title || '',
              label: lessonObject?.label || '',
              url: getLessonStepUrl(classroomName, curr[0], subUnitObject?.url, subUnitIndex % 4, lessonIndex, 0),
            });
          });
        });
      });
      return acc;
    },
    [[], []] as ElementaryLessonsWithStandards[],
  );
};

export const getUniqueMetStandards = (completedLessons: ElementaryLessonsWithStandards): string[] => {
  const standardsOnly = completedLessons.map((lesson) => lesson.standards);
  return [...new Set(standardsOnly.flat())];
};

export const getTotalCompletedStandards = (completedLessons: ElementaryLessonsWithStandards) =>
  getUniqueMetStandards(completedLessons).length;

export const getCompleteAndIncompleteByUnit = (
  completedLessons: ElementaryLessonsWithStandards,
  incompleteLessons: ElementaryLessonsWithStandards,
): {
  id: string;
  displayName: string;
  completeStandards: string[];
  incompleteStandards: string[];
}[] => {
  const unitStandardsCompletion = elementaryUnits.map((unit) => {
    const unitCompletedStandards = completedLessons
      .filter((lesson) => lesson.unitId === unit.unit)
      .map((unit) => unit.standards)
      .flat();
    const uniqueCompleteStandards = [...new Set(unitCompletedStandards)];
    const unitIncompleteStandards = incompleteLessons
      .filter((lesson) => lesson.unitId === unit.unit)
      .map((unit) => unit.standards)
      .flat();
    const uniqueIncompleteStandards = [...new Set(unitIncompleteStandards)].filter(
      (standard) => !uniqueCompleteStandards.includes(standard),
    );
    return {
      id: unit.unit,
      displayName: unit.displayName,
      completeStandards: uniqueCompleteStandards,
      incompleteStandards: uniqueIncompleteStandards,
    };
  });
  return unitStandardsCompletion;
};
